import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-fees-dialog',
  templateUrl: './fees-dialog.component.html',
  styleUrls: ['./fees-dialog.component.css'],
})
export class FeesDialogComponent {
  feeStructure = [
    { range: '£10-£14', percentage: '4.00%' },
    { range: '£15-£19', percentage: '3.50%' },
    { range: '£20-£49', percentage: '3.00%' },
    { range: '£50+', percentage: '2.50%' },
  ];

  examples = [
    ...Array.from({ length: 41 }, (_, i) => i + 10).map((cost) => {
      let feePercent =
        cost <= 14 ? 4.0 : cost <= 19 ? 3.5 : cost <= 49 ? 3.0 : 2.5;

      const feeAmount = (cost * feePercent) / 100;
      return {
        cost,
        feePercent,
        feeAmount,
        proceeds: cost - feeAmount,
      };
    }),
    { cost: 100, feePercent: 2.5, feeAmount: 2.5, proceeds: 97.5 },
    { cost: 150, feePercent: 2.5, feeAmount: 3.75, proceeds: 146.25 },
    { cost: 200, feePercent: 2.5, feeAmount: 5.0, proceeds: 195.0 },
  ];

  constructor(public dialogRef: MatDialogRef<FeesDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
